<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header">
      <div class="px-3 col-3 p-0">
        <div class="heading-solar">{{$t('result.round')}}</div>
        <div class="text-subhead">{{data.roundId}}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-solar">{{$t('result.bet')+`(${currency})`}}</div>
          <div class="text-subhead">{{data.bet | currencyFormatter}}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-solar">{{$t('result.winlose')+`(${currency})`}}</div>
          <div class="text-subhead">{{data.winlose | currencyFormatter}}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-solar">{{$t('result.balance')+`(${currency})`}}</div>
          <div class="text-subhead">{{data.balance | currencyFormatter}}</div>
      </div>
    </div>
    <div class="content-result pt-3">
      <div class="text-game-solar">{{'Solar Space'}}</div>
      <div class="text-subgame">{{$t('solar.name')}}</div>
      <div class="text-date mb-1">{{data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div v-if="data.freeSpin" class="col-1 d-flex align-items-center justify-content-center">
          <i class="fas fa-caret-left arrow-side" @click="delCount()"></i>
        </div>
        <div class="container d-flex flex-column justify-content-center" :class="baseSpins ? 'table-solar' : freeSpinsAlien ? 'table-alien' : 'table-human'">
          <table>
              <tbody>
                <tr v-for="(row, index) in table" :key="index">
                  <td v-for="(col, i) in row" :key="`${index}${i}`">
                    <img v-if="baseSpins" class="icon-symbol" :src="require(`../../assets/resultGame/solarSpace/Solar-Space_symbol_${col}.png`)"
                      alt="">
                    <img v-if="freeSpinsAlien" class="icon-symbol" :src="require(`../../assets/resultGame/solarSpace/Alien_symbol_${col}.png`)"
                      alt="">
                    <img v-if="freeSpinsHuman" class="icon-symbol" :src="require(`../../assets/resultGame/solarSpace/Human_symbol_${col}.png`)"
                      alt="">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        <div v-if="data.freeSpin" class="col-1 d-flex align-items-center justify-content-center">
          <i class="fas fa-caret-right arrow-side"  @click="addCount()"></i>
        </div>
      </div>
      <div v-if="data.freeSpin" class="text-subgame mb-1">{{$t('result.freespin') + ' ' + data.detail.freeSpinsPlayed + '/' + data.detail.freeSpinsCount}}</div>
      <div v-if="data.freeSpin" class="text-game">{{$t('result.multiplier') + ' ' + 'x' + data.detail.freeSpinsCurrentMultiplier}}</div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{$t('result.detail')}}</div>
        <hr class="line col-3">
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="bet-box p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in data.detail.winCombos" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper item">
                <div class="d-flex justify-content-start bet-wrapper item">           
                    <img v-if="baseSpins" class="icon-detail" :src="require(`../../assets/resultGame/solarSpace/Solar-Space_symbol_${detail[0]}.png`)"
                      alt="">
                    <img v-if="freeSpinsAlien" class="icon-detail" :src="require(`../../assets/resultGame/solarSpace/Alien_symbol_${detail[0]}.png`)"
                      alt="">
                    <img v-if="freeSpinsHuman" class="icon-detail" :src="require(`../../assets/resultGame/solarSpace/Human_symbol_${detail[0]}.png`)"
                      alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 green">{{`${detail[1]} `+ $t('result.kind')}}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{currency}} {{ (data.freeSpin 
                      ? (data.detail.freeSpinsCurrentMultiplier === 0 
                      ? (data.detail.winnings[index] * 1)
                      : (data.detail.winnings[index] * data.detail.freeSpinsCurrentMultiplier))
                      : (data.detail.winnings[index])
                      ) | currencyFormatter}}</p>
                  </div>              
                </div>
              </div>
            </div>
          </div>
          <div class="bet-warpper item" v-if="data.detail.winShowsCount === 0">
            <div class="d-flex justify-content-between mt-5">
              <div class="bet-wrapper item align-content-center d-flex">
                <div class="d-flex justify-content-center bet-wrapper item align-content-center p-3">
                    <p class="my-1 red">{{'No Winnings'}}</p>            
                </div>
              </div>
            </div>
          </div>
        </div>
       </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-solar',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 4, 7, 10, 13,],
        [2, 5, 8, 11, 14,],
        [3, 6, 9, 12, 15,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date)},
      date: '',
      time: '',
      result: this.data,
      count: this.data.count,
      freeSpinsAlien: false,
      freeSpinsHuman: false,
      baseSpins: false,
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1, 
    }
  },
  async created() {
    await this.mapSymbol()
  },
  methods: {  
    onResize() {
      this.headerHeight = document.getElementsByClassName('header')[0].offsetHeight
    },
    mapSymbol() {
         if (this.data.freeSpin && this.data.detail.freeSpinsPlayed > 0) {
          ![null, undefined].includes(this.data.detail.freeSpinsSelectedSide)
          ? this.data.detail.freeSpinsSelectedSide === 1
          ? this.freeSpinsAlien = true : this.freeSpinsHuman = true : this.baseSpins = true
          const reel1 = this.data.game.config.freeGameReel1
          const reel2 = this.data.game.config.freeGameReel2
          const reel3 = this.data.game.config.freeGameReel3
          const reel4 = this.data.game.config.freeGameReel4
          const reel5 = this.data.game.config.freeGameReel5
          
          const indexReel1 = this.data.detail.freeReelStopIndexes[0]
          const indexReel2 = this.data.detail.freeReelStopIndexes[1]
          const indexReel3 = this.data.detail.freeReelStopIndexes[2]
          const indexReel4 = this.data.detail.freeReelStopIndexes[3]
          const indexReel5 = this.data.detail.freeReelStopIndexes[4]

          this.table[0][0] = reel1[indexReel1]
          this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
          this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
          this.table[0][1] = reel2[indexReel2]
          this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
          this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
          this.table[0][2] = reel3[indexReel3]
          this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
          this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
          this.table[0][3] = reel4[indexReel4]
          this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
          this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
          this.table[0][4] = reel5[indexReel5]
          this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
          this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
        } else {
          this.baseSpins = true
          const reel1 = this.data.game.config.baseGameReel1
          const reel2 = this.data.game.config.baseGameReel2
          const reel3 = this.data.game.config.baseGameReel3
          const reel4 = this.data.game.config.baseGameReel4
          const reel5 = this.data.game.config.baseGameReel5

          const indexReel1 = this.data.detail.baseReelStopIndexes[0]
          const indexReel2 = this.data.detail.baseReelStopIndexes[1]
          const indexReel3 = this.data.detail.baseReelStopIndexes[2]
          const indexReel4 = this.data.detail.baseReelStopIndexes[3]
          const indexReel5 = this.data.detail.baseReelStopIndexes[4]

          this.table[0][0] = reel1[indexReel1]
          this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
          this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
          this.table[0][1] = reel2[indexReel2]
          this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
          this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
          this.table[0][2] = reel3[indexReel3]
          this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
          this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
          this.table[0][3] = reel4[indexReel4]
          this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
          this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
          this.table[0][4] = reel5[indexReel5]
          this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
          this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
        }
    },  
    async addCount() {
    const countData = this.data.count + 1
    this.$emit('fetchResult', countData)
     await this.mapSymbol()
    },
    async delCount() {
      const countData = this.data.count - 1
      this.$emit('fetchResult', countData)
      await this.mapSymbol()
    },
  }
}
</script>

<style scoped>

.icon-detail {
  width: 100px;
  height: 90px;
}

.arrow {
  color :#cac095;
  text-align:center;
}

.arrow-side {
  color :#cac095;
  text-align:center;
  font-size: 90px;
}

.bet-box {
  background: #0c161f;
  border-radius: 10px;
  min-height:200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper .item {
  color: #fff;
  background: #06112d;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box .bet-wrapper:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper, .result-wrapper {
  font-size: 35px;
}

.header {
  background: #0d1b28;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header > div {
  flex-grow: 1;
  font-size: 18px;
  line-height: 1.1;
}

.heading-solar {
  color: #30c7ee;
  text-align: center;
}

.content-result {
  background: #292933;
  height: 150vh;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title > .heading {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title > .sub {
  font-size: 30px;
  line-height: 1;
}

.text-game-solar {
  color: #30c7ee;
  font-size: 25px;
  text-align: center;
}

.text-subhead {
  font-size: px;
  color:white;
  text-align: center;
}

.text-subgame {
  font-size: 20px;
  color:white;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #c7b873;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol {
  width: 100%;
}

 .bet-box {
    min-width: 600px;
    max-width: auto;
  }

.table-solar {
  background: url('~@/assets/resultGame/solarSpace/Fram.png') no-repeat;
  background-size: 780px 580px;
  width: 770px;
  height: 500;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

.table-alien {
  background: url('~@/assets/resultGame/solarSpace/Fram_Red.png') no-repeat;
  background-size: 780px 580px;
  width: 770px;
  height: 500;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

.table-human {
  background: url('~@/assets/resultGame/solarSpace/Fram_Green.png') no-repeat;
  background-size: 780px 580px;
  width: 770px;
  height: 500;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-solar {
  background-size: 700px 500px;
  width: 700px;
  height: 500px;
}

  .table-alien {
  background-size: 700px 500px;
  width: 700px;
  height: 500px;
}

  .table-human {
  background-size: 700px 500px;
  width: 700px;
  height: 500px;
}
  .wrapper {
    flex-direction: column;
  }

  .wrapper > div:first-child {
    order: 2;
  }

  .wrapper > div:last-child {
    order: 1;
  }
  .arrow-side {
  font-size: 60px;
  }
   .bet-box {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }
   .bet-wrapper, .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper, .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height:2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading {
    font-size: 18px;
  }

  .icon-detail {
  width: 70px;
  height: 100px;
  }

  .table-solar {
  background-size: 540px 390px;
  width: 540px;
  height: 390;
  /* margin-bottom: 1%; */
  padding-bottom: 100px;

  }

  .table-alien {
  background-size: 540px 390px;
  width: 540px;
  height: 390;
  /* margin-bottom: 1%; */
  padding-bottom: 100px;

  }

  .table-human {
  background-size: 540px 390px;
  width: 540px;
  height: 390;
  /* margin-bottom: 1%; */
  padding-bottom: 100px;

  }

  .text-subhead {
  font-size: 18px;
  }

  .arrow-side {
  font-size: 50px;
  }

  .bet-box {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header > div {
    flex-grow: 0;
    font-size: 12px;
    width: 25%;
  }

  .heading {
    font-size: 12px;
  }

  .table-solar {
  background-size: 310px 230px;
  width: 310px;
  height: 230px;
  padding-top: 6.4rem;
  }

  .table-alien {
  background-size: 310px 230px;
  width: 310px;
  height: 230px;
  padding-top: 6.4rem;
  }

  .table-human {
  background-size: 310px 230px;
  width: 310px;
  height: 230px;
  padding-top: 6.4rem;
  }

  .text-subhead {
  font-size: 14px;
  }

  .bet-box {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

   .bet-wrapper, .result-wrapper {
    font-size: 20px;
  }

  .icon-detail {
  width: 50px;
  height: 60px;
  }
}


</style>